<div class="heading_sert">
  <sm-title-bar pageTitle="Access control" [back]="true"> </sm-title-bar>
</div>
<div class="price_part_lookz" *ngIf="!loader && functionalityList.length > 0">
  <div class="create_opl">
    <div class="likely_section">
      <div class="create_employees_ben">
        <div class="mat-card">
          <div class="wht_headinght">
            <div class="floting_option_menu">
              <div class="option_ser">
                <button mat-icon-button [matMenuTriggerFor]="homeMenu">
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #homeMenu="matMenu">
                  <button mat-menu-item (click)="openeditaccess()">
                    <mat-icon class="material-icons-outlined">edit</mat-icon>
                    Edit access
                  </button>
                </mat-menu>
              </div>
            </div>
            <h3>Accessible feature and functionality</h3>
            <p>
            Here's the list of functionality or section this employee can access. Functionality with green tick are open to access and the red ones inaccessible in this business.
            </p>
          </div>
          <div class="assistant_benf">
            <div class="row">
              <!-- Static items -->
              <div class="col-sm-4" *ngFor="let item of functionalityList">
                <div class="cardfg_se">
                  <mat-icon class="material-icons check" *ngIf="item.access_status == 1">check</mat-icon>
                  <mat-icon class="material-icons closeb" *ngIf="item.access_status != 1">close</mat-icon>

                  {{ item.functionality_name }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- mat-card -->
      </div>
    </div>
  </div>
</div>
